module.exports = __webpack_public_path__ + "img/nt15-00-75-1.asm.45f47ac5.jpg";